import {ColumnsType} from 'antd/lib/table/Table';
import {Dropdown, Menu} from 'antd';
import IntlMessages from '../../../../../../domain/utility/IntlMessages';
import {PredefinedProductAttributeValuesDto} from '../../../../../../shared/services/product-attribute/dto/predefined-product-attribute-values-dto';
import {BsCheckLg, BsXLg} from 'react-icons/bs';
import {AiFillDelete, AiFillEdit} from 'react-icons/ai';
import {ProductAttributeType} from '../../../../../../shared/constants/AppEnums';
import {useNavigate} from 'react-router-dom';
import {MdOutlineColorLens} from 'react-icons/md';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import RowActionsButton from 'src/shared/components/row-actions';

const TableColumn = (
  productAttributeType: string,
  openModal: Function,
  predefinedValueDelete: Function,
): ColumnsType<any> => {
  const navigate = useNavigate();
  const {locale}: any = useLocaleContext();

  const goToManageSubColorPage = (
    item: PredefinedProductAttributeValuesDto,
  ) => {
    navigate(
      `/catalog/catalog.attributes/product-attributes/mange-subColor/${item.Id}`,
      {
        state: {
          name: item?.Name,
          locales: item?.Locales,
        },
      },
    );
  };

  return [
    {
      title: <IntlMessages id='common.name' />,
      dataIndex: 'Name',
      key: 'Name',
      width: '40%',
      render: (value: string, record: PredefinedProductAttributeValuesDto) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: (
        <IntlMessages id='productAttributes.productAttributesPredefinedValues.priceAdjustment' />
      ),
      dataIndex: 'PriceAdjustment',
      key: 'PriceAdjustment',
      className: 'col-num',
      width: '20%',
    },
    {
      title: (
        <IntlMessages id='productAttributes.productAttributesPredefinedValues.isPreSelected' />
      ),
      dataIndex: 'IsPreSelected',
      key: 'IsPreSelected',
      render: (value: any) =>
        value ? <BsCheckLg color='green' /> : <BsXLg color='red' />,
      width: '20%',
      className: 'col-center',
    },
    {
      title: <IntlMessages id='category.Action' />,
      render: (text: string, item: PredefinedProductAttributeValuesDto) => {
        return (
          <div>
            <Dropdown
              trigger={['click']}
              overlay={() => (
                <Menu>
                  <Menu.Item onClick={() => openModal(item)} key={'edit'}>
                    <AiFillEdit className='icon-in-action' />
                    <span className='margin-in-action'>
                      <IntlMessages id='common.edit' />
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    onClick={() => predefinedValueDelete(item)}
                    key={'delete'}>
                    <AiFillDelete className='icon-in-action' />
                    <span className='margin-in-action'>
                      <IntlMessages id='common.delete' />
                    </span>
                  </Menu.Item>
                  {productAttributeType === ProductAttributeType.Color && (
                    <Menu.Item
                      onClick={() => goToManageSubColorPage(item)}
                      key={'manageSubColors'}>
                      <MdOutlineColorLens className='icon-in-action' />
                      <span className='margin-in-action'>
                        <IntlMessages id='productAttributes.productAttributesPredefinedValues.manageSubColors' />
                      </span>
                    </Menu.Item>
                  )}
                </Menu>
              )}
              placement='bottomRight'>
              <RowActionsButton />
            </Dropdown>
          </div>
        );
      },
      className: 'col-actions',
      width: 80,
    },
  ];
};

export default TableColumn;
